<div class="container">
    <h3 *ngIf="onCalendarPage" class="d-flex justify-content-center lime-green-button text-white rounded-pill p-3 fs-5">
      <fa-icon class="me-2 fa-lg" [icon]="faCalendar"></fa-icon>Prihajajoči dogodki
    </h3>
    <div *ngIf="displayedEvents.length === 0" class="col-12 d-flex justify-content-center" style="color: gray; font-style: italic;">
      <h2 class="text-center my-5">Na žalost ni dogodkov.</h2>
    </div>
    
    <!-- Scrollable Events Row -->
    <div #eventsRow class="events-scroll-row d-flex overflow-auto">
      <div class="col-sm-6 col-md-4 col-lg-3" *ngFor="let event of displayedEvents">
        <div class="event-card p-2" (click)="openEventDetails($event, event)">
          <div class="event-image-container">
            <img [src]="event.imageRef" alt="{{ event.title }}" class="event-image">
          </div>
          <div class="event-content">
            <h2 class="event-title">{{ event.title }}</h2>
            <p class="event-date" [ngClass]="{'highlighted-date': event.exposed}">
              <span class="event-day">{{ formatDate(event.start, 'd') }}</span>
              <span class="event-month">{{ formatDate(event.start, 'MMMM') }}</span>
              <span class="event-year">{{ formatDate(event.start, 'yyyy') }}</span>
            </p>
            
            <span *ngIf="event.exposed" class="label-gradient align-items-center mt-3 mb-3">
              <fa-icon class="me-2 fa-lg" [icon]="faStar"></fa-icon>Naj dogodek</span>
              <p class="organisation">
                <fa-icon class="me-2 fa-lg center" [icon]="faUser"></fa-icon>
                <a [routerLink]="['/organisation', event.organisationSlug]" class="news-author">
                  {{ event.organisationName }}
                </a>
              </p>
          </div>
        </div>
        <div *ngIf="onAdminPage || isOrgAdmin || isSuperAdmin" class="d-flex flex-column align-items-center mt-3">
          <button class="btn btn-outline-danger mb-2" (click)="deleteEvent(event)">
              <fa-icon class="me-3" [icon]="faTrash"></fa-icon>Izbriši dogodek
          </button>
          <button class="btn btn-outline-primary mb-2" (click)="openEventEdit(event)">
              <fa-icon class="me-3" [icon]="faPen"></fa-icon>Uredi dogodek
          </button>
          <button class="btn btn-outline-warning" (click)="toggleExposeEvent(event.eventID)">
              <fa-icon class="me-3" [icon]="faStar"></fa-icon>{{ event.exposed ? 'Ne izpostavi' : 'Izpostavi' }}
          </button>
      </div>
      
      </div>
            <!-- Load More Button -->
  <div *ngIf="showLoadMoreButton" class="d-flex justify-content-center mt-3">
    <button class="btn btn-custom" (click)="loadMoreEvents()">
      <fa-icon class="me-3" [icon]="faPlus"></fa-icon>Prikaži več
    </button>
  </div>
    </div>

  
    <!-- Admin Buttons -->
    <div *ngIf="onAdminPage" class="d-flex justify-content-center mt-3">
      <button class="btn btn-custom" (click)="openEventAdd()">
        <fa-icon class="me-3" [icon]="faPlus"></fa-icon>Dodaj dogodek
      </button>
    </div>
    <div *ngIf="onOrganisationPage && !onAdminPage && isOrgAdmin || isSuperAdmin" class="d-flex justify-content-center mt-3">
      <button class="btn button-74" (click)="openEventAdd()">
        <fa-icon class="me-3" [icon]="faPlus"></fa-icon>Dodaj dogodek
      </button>
    </div>
  </div>
  